<template>
    <div v-if="podcast" class="w-full">
        <!-- Podcast Header -->
        <div class="bg-gradient-to-r from-nomad-800 to-nomad-900 rounded-lg overflow-hidden mb-8 p-6 md:p-8">
            <div class="grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
                <!-- Podcast Image -->
                <div class="md:col-span-4">
                    <img :src="podcast.image" :alt="podcast.title" class="rounded-lg w-full shadow-lg object-cover" />
                </div>

                <!-- Podcast Info -->
                <div class="md:col-span-8 space-y-4">
                    <!-- Title -->
                    <h1 class="text-white font-bold text-3xl md:text-4xl">{{ podcast.title }}</h1>

                    <!-- Host -->
                    <div class="space-y-2">
                        <h3 class="text-nomad-300 text-sm uppercase tracking-wide font-medium">Host</h3>
                        <p class="text-lg text-nomad-200 font-semibold" v-html="podcast.host"></p>
                    </div>

                    <!-- Episode Count -->
                    <div class="space-y-2">
                        <h3 class="text-nomad-300 text-sm uppercase tracking-wide font-medium">Episodes</h3>
                        <p class="text-lg text-nomad-200">{{ podcast.episodes_count }} {{ podcast.episodes_count === 1 ?
                            'episode' : 'episodes' }}</p>
                    </div>

                    <!-- Description -->
                    <div v-if="podcast.description" class="pt-2">
                        <h3 class="text-nomad-300 text-sm uppercase tracking-wide font-medium mb-2">About</h3>
                        <p class="text-nomad-200 font-light leading-relaxed">{{ podcast.description }}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Episodes Section -->
        <div v-if="podcast.episodes && podcast.episodes.length">
            <h2 class="text-2xl font-bold text-white mb-6">Episodes</h2>
            <ul class="space-y-3">
                <li v-for="episode in podcast.episodes" :key="episode.id">
                    <episode-card :episode="episode" />
                </li>
            </ul>
        </div>

        <!-- Empty State -->
        <div v-else class="text-center py-12">
            <p class="text-nomad-300 text-lg">No episodes available</p>
        </div>
    </div>
</template>
<script setup>
defineProps({ podcast: Object });
</script>
<script>
import { defineAsyncComponent } from 'vue'
import { mapState, mapActions } from "vuex";
import { usePage } from "@inertiajs/vue3";
import EpisodeCard from "@/components/EpisodeCard.vue";
export default {
    methods: {
        ...mapActions("podcast", ["getSignlePodcast"]),
    },
    beforeMount() {
        document.title = this.podcast.title + ' by ' + this.podcast.host
    },
    components: {
        EpisodeCard,
        'adsense': defineAsyncComponent(() => import("@/components/Adsense.vue")),
    }
};
</script>
